<template>
  <div class="controller">
    <div class="label">{{ label }}</div>
    <div class="content">
      <el-radio :value="value" @input="$emit('input', 1)" :label="1">启用</el-radio>
      <el-radio :value="value" @input="$emit('input', 0)" :label="0">禁用</el-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'controller',
  props: {
    label: {
      type: String
    },
    value: {
      type: Number
    }
  }
};
</script>

<style scoped lang="scss"></style>
